import { Flex, FlexProps } from "@mantine/core";

import {
  NAVBAR_ITEM_COLLAPSED_WIDTH,
  NAVBAR_ITEM_EXPANDED_WIDTH,
  NAVBAR_ITEM_HEIGHT,
} from "../constants/navbar";

interface NavBarItemProps extends FlexProps {
  collapsed?: boolean;
  label: string;
}

export default function NavBarItem({ collapsed, children, label, ...props }: NavBarItemProps) {
  const commonProps = {
    h: NAVBAR_ITEM_HEIGHT,
    bg: "gray.1",
    px: collapsed ? 0 : 4,
    align: "center",
    ...props,
  };

  return (
    <>
      <Flex
        w="100%"
        hiddenFrom="sm"
        justify="flex-start"
        {...commonProps}
        data-testid={`mobile-navbar-item-${label}`}
      >
        {children}
      </Flex>
      <Flex
        visibleFrom="sm"
        data-testid={`desktop-navbar-item-${label}`}
        justify={collapsed ? "center" : "flex-start"}
        style={{ borderRadius: "var(--mantine-radius-md)" }}
        w={collapsed ? NAVBAR_ITEM_COLLAPSED_WIDTH : NAVBAR_ITEM_EXPANDED_WIDTH}
        {...commonProps}
      >
        {children}
      </Flex>
    </>
  );
}
